export default [
    {
        path: "add-inapp-ios-setting",
        name: "addinappiossetting",
        component: () =>
            import(
                /* webpackChunkName: "AddSingleSubscriber" */ "../pages/inappIOS/AddInappIOSSetting.vue"
            ),
        meta: {
            title: `Add Inapp IOS Setting`,
        },
    }
];
